import { isEmpty, isNil } from 'lodash-es';
export const metricUsingMaxAgg = [
    'RR',
    'FF',
    'FXY',
    'HPOT',
    'LW_V',
    'LW_D'
];
export const metricUsingMinAgg = [
    'T_WET',
    'T_DRY',
    'U_CAPA',
    'HDEF',
    'ECP',
    'SWC'
];
export const metricUsingMedianAgg = [
    'T',
    'T_SOIL',
    'U',
    'DD',
    'PPFD',
    'PPFD_MAX',
    'PPFD_MIN',
    'SSI',
    'SSI_MAX',
    'SSI_MIN'
];
export const median = (arr) => {
    const filteredResult = arr?.filter((x) => !isNil(x));
    if (isEmpty(filteredResult) || isNil(filteredResult))
        return null;
    if (filteredResult.length === 1)
        return filteredResult[0];
    const s = filteredResult.sort((a, b) => a - b);
    const mid = Math.floor(s.length / 2);
    return s.length % 2 === 0 ? (s[mid - 1] + s[mid]) / 2 : s[mid];
};
